export const EDUCATION_PROGRAM_OTHER = 'other';
